import React, {useState} from 'react';
import {connect} from 'react-redux';
import {compose} from '../../utils'
import Order from "../../services/order";

const orderService = new Order();

const Step4 = (props) => {
    let styles = {marginBottom:0,lineHeight: "22px"};

    const [callbackMe, setCallbackMe] = useState(false);

    const handleCallMeBtn = () => {
        setCallbackMe(true);

        orderService.callbackMe({
            id: props.orderId,
        });
    };

    return (
        <div className="modal-content product-request__wrapper modalType2-step modalType2-step4 active"
             data-currensstep="4">
            <p className="title" style={styles}>
                Спасибо! Ваш заказ № {props.orderId}
            </p>
            <p className="title" style={styles}>
                подтвержден и в ближайшее время будет
            </p>
            <p className="title" style={styles}>
                передан на сборку
            </p>
            <br />
            {!callbackMe &&
                <button onClick={handleCallMeBtn} className="product-request__button modalType2--submitBtn" style={{fontSize:"17px", fontWeight:"normal", textTransform:"none"}}>Перезвонить мне</button>
            }
            {callbackMe &&
                <p style={{marginTop:"20px"}}>Спасибо, с вами свяжется менеджер</p>
            }
            <p style={{marginTop: "20px", lineHeight: "1.5"}}>
                8 (499) 681-19-79<br/>
                9:00-21:00 (мск.) | Пн.-Вс.
            </p>
        </div>
    );
};

const mapStateToProps = ({orderId}) => {
    return {orderId};
};

export default compose(
    connect(mapStateToProps)
)(Step4);
